import { render } from "./BusinessCard.vue?vue&type=template&id=5de08495"
import script from "./BusinessCard.vue?vue&type=script&lang=js"
export * from "./BusinessCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__